import React, { useState, useEffect } from "react";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import { useApiFetch } from "../utils/apiFetch";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";
import ConsultarPuertosPp from "./ConsultarPuertosPp";

function ReportePp() {
    const { setModuloActual, setSubModuloActual, setElementoSeleccionado, logout } = useGlobal();
    const apiFetch = useApiFetch();
    const [arrayPatchPanels, setArrayPatchPanels] = useState([]);
    const [patchSeleccionado, setPatchSeleccionado] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [confirmar, setConfirmar] = useState(false);  // Estado para controlar el mensaje de confirmación de eliminar
    const [vistaLocal, setVistaLocal] = useState("lista");

    // Función inicial para llenar el array que contendra los patch panels existentes: arrayPatchPanels
    useEffect(() => {
        const fetchPatchPanels = async () => {
            setLoading(true);
            setError("");
            setSuccess("");

            try {
                const data = await apiFetch(
                    "consultar_patch_panels.php",
                    { method: "GET" },
                    logout
                );

                if (data.status === "ok") {
                    setArrayPatchPanels(data.data);
                    setSuccess("Registros encontrados.");
                } else {
                    setError(data.message || "Error al consultar patch panels.");
                    setTimeout(() => {
                        setModuloActual("Reportes");
                        setSubModuloActual(null);
                        setConfirmar(false);
                    }, 2000);
                }
            } catch (err) {
                setError("Error de conexión con el servidor: " + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPatchPanels(); // Ejecutar esta función
    }, []);

    const handleSelect = (pp) => {
        setPatchSeleccionado(pp);
    };

    // Función para exportar uno o todos los registros
    const handleExportar = () => {
        let registrosParaExportar = [];

        if (patchSeleccionado) {
            const seleccionado = arrayPatchPanels.find(pp => pp.patch === patchSeleccionado);
            if (seleccionado) {
                registrosParaExportar = [seleccionado];  // Se asigna el objeto "seleccionado" exporta un solo patch panel
            }
        } else {
            registrosParaExportar = arrayPatchPanels;  // Se asigna todo el objeto de arrays al array de los registros para exportar
        }

        // Definiendo los encabezados de las columnas para el archivo a exportar
        const headers = [
            "Nombre",
            "Puertos",
            "Sede",
            "Edificio",
            "Nivel",
            "Descripción"
        ];

        // Convertir a CSV
        const csvRows = [];
        csvRows.push(headers.join(",")); // La primera fila serán los encabezados

        registrosParaExportar.forEach(pp => {   // Las filas siguientes seran los registros que esten en el array registrosParaExportar
            const row = [
                `"${pp.patch}"`,
                `"${pp.puertos}"`,
                `"${pp.acronimo}"`,
                `"${pp.edificio}"`,
                `"${pp.nivel}"`,
                `"${pp.desc_patch}"`
            ];
            csvRows.push(row.join(","));
        });

        const csvString = csvRows.join("\n");

        // Crear archivo descargable
        const BOM = "\uFEFF"; // Marca de Orden de Bytes para UTF-8
        const blob = new Blob([BOM + csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "patch_panels.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Función para exportar en PDF
    const handleExportarPDF = () => {
        let registrosParaExportar = [];

        if (patchSeleccionado) {
            const seleccionado = arrayPatchPanels.find(pp => pp.patch === patchSeleccionado);
            if (seleccionado) {
                registrosParaExportar = [seleccionado]; // solo el seleccionado
            }
        } else {
            registrosParaExportar = arrayPatchPanels; // toda la lista
        }

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Listado de Patch Panels", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla
        autoTable(doc, {
            startY: 50,
            head: [["Nombre", "Puertos", "Sede", "Edificio", "Nivel", "Descripción"]],
            body: registrosParaExportar.map(pp => [
                pp.patch,
                pp.puertos,
                pp.acronimo,
                pp.edificio,
                pp.nivel,
                pp.desc_patch
            ])
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2025-2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        // Nombre dinámico del archivo
        const nombreArchivo = patchSeleccionado
            ? `patch_${patchSeleccionado}.pdf`
            : "patch_panels.pdf";

        doc.save(nombreArchivo);
    };

    // Función para desmarcar
    const handleDesmarcar = () => {
        setPatchSeleccionado(null);
        setElementoSeleccionado(null);
    };

    // Función para modificar los puertos del patch panel seleccionado
    const handleConsultarPuertos = () => {
        if (!patchSeleccionado) {
            alert("Por favor selecciona un patch panel para modificar.");
            return;
        }

        const seleccionado = arrayPatchPanels.find(pp => pp.patch === patchSeleccionado);

        if (seleccionado) {
            setElementoSeleccionado(seleccionado);
            setVistaLocal("consultarPuertos");
            setConfirmar(false);
        }
    };

    // Función para resetear los mensajes después de un tiempo
    useEffect(() => {
        if (error || success) {
            const timer = setTimeout(() => {
                setError("");
                setSuccess("");
            }, 2000);

            return () => clearTimeout(timer); // Limpiar si cambia antes del tiempo
        }
    }, [error, success]);

    return (
        <div className="sesion-form">
            {loading && <p>Cargando patch panels...</p>}
            {error && <p className="error">{error}</p>}
            {/*success && <p className="success">{success}</p>*/}

            {vistaLocal === "lista" && (
                <>
                    {arrayPatchPanels.length > 0 && (
                        <>
                            <table className="tabla-estandar seleccion-unica">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Nombre</th>
                                        <th>Sede</th>
                                        <th>Edificio</th>
                                        <th>Nivel</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {arrayPatchPanels.map((pp, index) => (
                                        <tr key={index}>
                                            <td data-label="Seleccionar">
                                                <input
                                                    type="checkbox"
                                                    checked={patchSeleccionado === pp.patch}
                                                    onChange={() => handleSelect(pp.patch)}
                                                />
                                            </td>
                                            <td data-label="Nombre Patch">{pp.patch}</td>
                                            <td data-label="Sede">{pp.acronimo}</td>
                                            <td data-label="Edificio">{pp.edificio}</td>
                                            <td data-label="Nivel">{pp.nivel}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="form-buttons">
                                <button type="button" onClick={handleConsultarPuertos} disabled={!patchSeleccionado}>Consultar<br></br>puertos</button>
                                <button type="button" onClick={handleExportar}>Exportar<br></br>en CSV</button>
                                <button type="button" onClick={handleExportarPDF}>Exportar<br />en PDF</button>
                                <button type="button" onClick={handleDesmarcar} disabled={!patchSeleccionado}>Desmarcar</button>
                            </div>
                        </>
                    )}
                </>
            )}

            {vistaLocal === "consultarPuertos" && (
                <ConsultarPuertosPp />
            )}

        </div>
    );
}

export default ReportePp;